import TagFilters from "./TagFilters";
import React from "react";
import {AreaView} from "./Area";
import I18n from "../I18n";

let rowRender = ({label}) => <AreaView name={label}/>;

export default ({...props}) => <TagFilters operator="and" attribute="areas" title={I18n.filters.areas} rowRender={rowRender} limit={55} {...props}/>
